import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-maintenance-and-updates',
  templateUrl: './maintenance-and-updates.component.html',
  styleUrls: ['./maintenance-and-updates.component.scss']
})
export class MaintenanceAndUpdatesComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Maintenance and Updates - Xipe Tech';
  contentDescription = 'Keep your systems running smoothly with XipeTech’s expert maintenance and updates. We ensure your IT infrastructure stays secure, up-to-date, and optimized for peak performance.';
  contentKeywords = 'IT maintenance, software updates, system updates, IT support, infrastructure maintenance, technology updates, system optimization, patch management, performance improvement, IT services maintenance';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
